import Exeggcute from './Exeggcute';

export default Exeggcute;



/** WEBPACK FOOTER **
 ** ./source/102-exeggcute/index.js
 **/